import { Box, Stack, Typography } from '@mui/material';
import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as APJHttp from '../../store/APJHttp';
import { getImgPath } from '../../store/JSTool';

export default function MobileProject(props) {

    const settingData = useSelector(state => state.settingData);

    return (

        <Stack
            id='_project_view'
            sx={{
                position: 'absolute',
                zIndex: 999,
                width: '100vw',
                bgcolor: 'black',
                top: '50px',
                display: 'none',
                pt: 1.5,
            }}>

            <Stack
                sx={{
                    overflow: 'hidden',
                    justifyContent: 'center',
                    flexDirection: 'row',
                }}>

                <ContentItem navId={props.navId} index={0} title='ONE PUNCH MAN: WORLD' imgName='logo_yq.png' />
                <ContentItem navId={props.navId} index={1} title='Street Fighter: Duel' imgName='logo_jb.png' showSFDUrl={props.showSFDUrl} hideSFDUrl={props.hideSFDUrl} />
                <ContentItem navId={props.navId} index={3} title='Lord of Nazarick' imgName='overlord_icon.png' />
            </Stack>


            <Stack
                sx={{
                    width: 1,
                    alignItems: 'center',
                    overflow: 'hidden',
                }}>

                {/* 横线 */}
                <Box
                    sx={{
                        width: 0.65,
                        bgcolor: 'white',
                        height: '1px'
                    }} />

                <Stack sx={{
                    flexDirection: 'row',
                    alignItems: 'center',
                }}>
                    <UrlItem title='EU&MENA' url='https://www.sfduelmobile.com' />
                    <UrlItem title='JAPAN' url='https://jp.sfduelmobile.com' />
                    <UrlItem title='KOREA' url='https://kr.sfduelmobile.com' />
                    <UrlItem title='SEA' url='https://sea.sfduelmobile.com' />
                </Stack>
            </Stack>
        </Stack>

    );

}

function ContentItem(props) {

    function itemTap() {
        if (props.index == 0) {
            window.open('https://eu.onepunchmanworld.com');

        } else if (props.index == 1) {
            // window.open('https://www.sfduelmobile.com');

        } else if (props.index == 2) {
            window.open('https://myherotsh.com/');

        } else if (props.index == 3) {
            window.open('https://lon.aplus-games.com/');

        }
    }

    return (
        <Stack
            onClick={itemTap}
            sx={{
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white',
                width: 0.25,
                cursor: 'pointer',
            }}>
            <Box component={'img'}
                src={getImgPath(props.imgName)}
                sx={{
                    height: '60px',
                    my: 1,
                }} />

            {/* 横线 */}
            <Box
                sx={{
                    visibility: props.index == 1 ? 'show' : 'hidden',
                    width: '40px',
                    bgcolor: 'white',
                    height: '1px'
                }} />

            {/* 竖线 */}
            <Box
                sx={{
                    visibility: props.index == 1 ? 'show' : 'hidden',
                    width: '1px',
                    bgcolor: 'white',
                    height: '15px'
                }} />

            <Typography sx={{
                display: 'none',
                fontFamily: 'Source Han Sans CN',
                fontSize: 9,
                ml: 1,
                whiteSpace: 'pre-line',
            }}>
                {props.title}
            </Typography>

            <Box
                component={'img'}
                src={getImgPath('arrow_right_black.png')}
                sx={{
                    display: 'none',
                    height: '6px',
                    width: '6px',
                    borderRadius: '6px',
                    p: '3px',
                    objectFit: 'contain',
                    bgcolor: 'white',
                }} />
        </Stack>


    );
}

function UrlItem(props) {

    function tap() {
        window.open(props.url);
    }

    return (
        <Stack
            onClick={tap}
            sx={{
                flexDirection: 'row',
                mx: 1.5,
                pt: 1,
                pb: 2,
                cursor: 'pointer',
                alignItems: 'center',
            }}>
            <Typography sx={{
                color: 'white',
                fontSize: 10,
                fontFamily: 'Lexend Deca',
            }}>
                {props.title}
            </Typography>

            <Box
                component={'img'}
                src={getImgPath('arrow_right_black.png')}
                sx={{
                    height: '6px',
                    width: '6px',
                    borderRadius: '6px',
                    p: '3px',
                    objectFit: 'contain',
                    bgcolor: 'white',
                    ml: '5px'
                }} />

        </Stack>
    );
}